// extracted by mini-css-extract-plugin
export default {"cls1":"PostComments-cls1___80c0593fb54ea139d6d","cls2":"PostComments-cls2___256b3f379d6cc9a47b0 PostComments-cls1___80c0593fb54ea139d6d"};